import React from 'react';
import { useDispatch } from 'react-redux';

import useUserProfile from '@src/hooks/useUserProfile';
import { setProfile as setProfileAction } from '@src/store/authentication/actions';

import useAuthenticationTokens from './useAuthenticationTokens';

const useRefreshProfile = () => {
  const {
    tokens: { userID, accessToken, setupComplete },
  } = useAuthenticationTokens();
  const dispatcher = useDispatch();
  const userProfile = useUserProfile(userID);
  React.useEffect(() => {
    if (!(userID && accessToken && setupComplete && userProfile.data)) {
      return;
    }
    if (!userProfile) {
      return;
    }
    dispatcher(setProfileAction(userProfile.data));
  }, [
    accessToken,
    dispatcher,
    setupComplete,
    userID,
    userProfile,
    userProfile.data,
    userProfile.loading,
  ]);
};

export default useRefreshProfile;
